// src/pages/PaymentsPage.js
import React, { useState } from 'react';
import './Legal.css';

const fetchJSON = async (url, opts = {}) => {
  const r = await fetch(url, opts);
  const ct = r.headers.get('content-type') || '';
  const body = ct.includes('json') ? await r.json() : await r.text();
  if (!r.ok) throw new Error(body?.detail || body?.message || String(body));
  return body;
};

export default function PaymentsPage() {
  const [err, setErr] = useState('');
  const token =
    (typeof localStorage !== 'undefined' &&
      (localStorage.getItem('clairifi_token') || localStorage.getItem('token'))) ||
    '';

  const upgrade = async () => {
    try {
      setErr('');
      const { url } = await fetchJSON('/api/billing/checkout', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
      window.location.href = url;
    } catch (e) {
      setErr(String(e.message || e));
    }
  };

  const portal = async () => {
    try {
      setErr('');
      const { url } = await fetchJSON('/api/billing/portal', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
      window.location.href = url;
    } catch (e) {
      setErr(String(e.message || e));
    }
  };

  return (
    <div className="legal-wrap">
      <h1>Payments & Billing</h1>
      {err && <div className="legal-alert">{err}</div>}

      <section>
        <h2>Plans</h2>
        <ul>
          <li><strong>Free Trial</strong> — 14 days. Dashboard, Strategy, Forecast. Uploads disabled.</li>
          <li><strong>Clairifi Core</strong> — $15/month. Full access, <strong>3 uploads/month</strong>.</li>
        </ul>
      </section>

      <section>
        <h2>Billing</h2>
        <p>Subscriptions renew monthly until canceled. Taxes may apply based on your location.</p>
        <p>Invoices and receipts are provided by Stripe. You can update your card or cancel anytime via the customer portal.</p>
        <div className="btn-row">
          <button className="btn" onClick={upgrade}>Upgrade to Core</button>
          <button className="btn-ghost" onClick={portal}>Manage billing</button>
        </div>
      </section>

      <section>
        <h2>Refunds & Cancellations</h2>
        <p>
          You can cancel anytime and retain access until the end of the billing period.
          Refunds are not issued except where required by law; if something went wrong,
          contact <a href="mailto:contact@getclairifi.com">contact@getclairifi.com</a>.
        </p>
      </section>

      <section>
        <h2>Usage Limits</h2>
        <p>Clairifi Core includes <strong>3 uploads per month</strong>. The counter resets at the start of each calendar month.</p>
      </section>
    </div>
  );
}
